import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "../context/AuthContext";

const LOGO_URL = "/logo.png";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function SignIn() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();

  useEffect(() => {
    if (!loading && user) {
      navigate(params.get("redirect") || "/account", { replace: true });
    }
  }, [user, loading, navigate, params]);

  const startLogin = () => {
    const redirectUrl = window.location.origin + "/account";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-16" data-testid="signin-page">
      <div className="max-w-md w-full bg-white rounded-3xl p-10 shadow-sm">
        <div className="flex justify-center mb-6">
          <img src={LOGO_URL} alt="Roop Anand" className="h-20 w-auto" />
        </div>
        <h1 className="font-serif text-4xl text-[#0A192F] text-center">Welcome back</h1>
        <p className="text-center text-[#666] mt-2 text-sm">Sign in to continue your Ayurvedic journey.</p>

        <button
          onClick={startLogin}
          className="mt-8 w-full flex items-center justify-center gap-3 border-2 border-[#0A192F] rounded-full py-4 text-[#0A192F] font-semibold hover:bg-[#0A192F] hover:text-white transition-colors"
          data-testid="google-signin-btn"
        >
          <svg className="h-5 w-5" viewBox="0 0 24 24">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          Continue with Google
        </button>

        <p className="text-center text-xs text-[#666] mt-6 leading-relaxed">
          By continuing, you agree to Roop Anand&apos;s Terms of Service and acknowledge our Privacy Policy.
        </p>
      </div>
    </div>
  );
}
